<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="d-flex">
                    <div class="align-self-center">
                        <h4 class="card-title m-t-10">Condominios Actuales</h4></div>
                    <div class="ml-auto">
                        <div class="input-group">
                            <a type="button" [routerLink]="['/admin/condominios/nuevo']" routerLinkActive="router-link-active"  class="btn btn-sm btn-warning btn-create">Nuevo Condominio</a>
                        </div>
                    </div>
                </div>
                <br>
                <div class="table-responsive m-t-40">
                    <table id="tabla-condominios" class="table table-bordered table-striped">
                        <thead>
                            <tr>

                                <th>Nombre</th>
                                <th>Dirección</th>
                                <th>Longitud</th>
                                <th>Latitud</th>
                                <th>Viviendas</th>
                                <th>Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of condominio_list">
                                <td>
                                    <a [routerLink]="['/admin/condominios', c.id]" routerLinkActive="router-link-active" ><img src="{{ c.imagen }}" alt="user" height="50" width="50" class="img-circle"> {{ c.nombre }}</a>
                                </td>
                                <td>{{ c.direccion }}</td>
                                <td>{{ c.long }}</td>
                                <td>{{ c.lat }}</td>
                                <td>{{ c.cantidad_viviendas }}</td>
                                <td> 
                                    <div class="btn btn-group">
                                        <button (click)="data_to_delete(c.id, c.nombre)" data-toggle="modal" data-target="#modal-eliminar" class="btn btn-danger"><i class="fa fa-trash-o"></i></button>
                                        <a type="button" [routerLink]="['/admin/condominios', c.id ]" routerLinkActive="router-link-active"  class="btn btn-secondary"> <i class="fa fa-edit"> </i></a>
                                    </div>
                                </td>
                            </tr>
                           
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
    </div>
</div>

<div id="modal-eliminar" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <form class="modal-dialog" [formGroup]="formDataDelete">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Eliminar Condominio</h4>
                <button type="button" (click)="condominio_id = 0; condominio_name = '';" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="alert alert-warning" role="alert">
                <a href="#" class="alert-link">¡Cosas inesperadas sucederán si no lees esto!</a>
            </div>
            <div class="modal-body">
                <strong>Esta acción no se puede deshacer.</strong>
                <br>
                <p>Esto eliminará permanentemente el condominio y todo lo relacionado
                    con el dejará de ser accesible.</p>
                <p>Escriba "<strong *ngIf="condominio_name">{{condominio_name}}</strong>" para confirmar.</p>
                <div class="form-group">
                    <input type="text" class="form-control" id="recipient-name" formControlName="nombreConfirm"
                        name="nombreConfirm">
                    <div *ngIf="formDataDelete.controls.nombreConfirm.invalid && (formDataDelete.controls.nombreConfirm.dirty || formDataDelete.controls.nombreConfirm.touched)">
                        <div class="alert alert-danger" role="alert" *ngIf="formDataDelete.controls.nombreConfirm.errors.required">
                            El título es requerido
                        </div>
                    </div>
                    <div *ngIf="!formDataDelete.controls.nombreConfirm.invalid && formDataDelete.controls.nombreConfirm.value != condominio_name">
                        <div class="alert alert-danger" role="alert">
                            Los nombres no coinciden
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="modal-footer">
                <button type="button" (click)="condominio_id = 0; condominio_name = '';" class="btn btn-secondary text-uppercase btn-rounded"
                    data-dismiss="modal">Cerrar</button>
                <button type="submit" (click)="delete()" [disabled]="formDataDelete.controls.nombreConfirm.value != condominio_name"
                    class="btn btn-danger text-uppercase btn-rounded">Eliminar</button>
            </div>
        </div>
    </form>
</div>